import { createContext, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FileModal from '../../video-overview/FileModal';
import { getDownloadUrl } from '../../../services/api/fileService';
import { useToast } from '../../../hooks/use-toast';
import { LinkedFileDTO } from '../../../services/apiService';

const PREVIEWABLE_TYPES = ['image', 'video', 'document'];

export const FilePreviewInApp = createContext(true);

export function useFilePreview(file: LinkedFileDTO) {
    const { t } = useTranslation();
    const { toast } = useToast();
    const inApp = useContext(FilePreviewInApp);
    const [opening, setOpening] = useState(false);
    const [viewerUrl, setViewerUrl] = useState<string | null>(null);
    const previewable = inApp && PREVIEWABLE_TYPES.includes(file.documentType);

    const open = async () => {
        setOpening(true);
        try {
            const url = await getDownloadUrl(file._id);
            if (!url) throw new Error('Empty download URL');
            if (previewable) {
                setViewerUrl(url);
            } else {
                window.open(url, '_blank', 'noopener,noreferrer');
            }
        } catch {
            toast({
                title: t('roomOverview.machineDetail.downloadError'),
                description: t(
                    'roomOverview.machineDetail.downloadErrorDescription'
                ),
                variant: 'destructive',
            });
        } finally {
            setOpening(false);
        }
    };

    const modal = viewerUrl ? (
        <FileModal
            file={{ ...file, url: viewerUrl, title: file.filename }}
            close={() => setViewerUrl(null)}
        />
    ) : null;

    return { open, opening, previewable, modal };
}
